var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "triplet" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("\n    三元组\n  ")]),
      _c(
        "el-form",
        { staticClass: "search-form", attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "订单号" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入订单号", clearable: "" },
                model: {
                  value: _vm.searchForm.orderNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "orderNo", $$v)
                  },
                  expression: "searchForm.orderNo",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { width: "360px" }, attrs: { label: "产品类型" } },
            [
              _c("a-cascader", {
                attrs: {
                  options: _vm.categoryList,
                  placeholder: "请选择产品类型",
                  clearable: "",
                },
                on: { change: _vm.handleCategory },
                model: {
                  value: _vm.categoryValue,
                  callback: function ($$v) {
                    _vm.categoryValue = $$v
                  },
                  expression: "categoryValue",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { width: "230px" }, attrs: { label: "产品名称" } },
            [
              _c("el-input", {
                staticStyle: { width: "160px" },
                attrs: { placeholder: "请输入产品名称", clearable: "" },
                model: {
                  value: _vm.searchForm.productName,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "productName", $$v)
                  },
                  expression: "searchForm.productName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { width: "200px" }, attrs: { label: "产品ID" } },
            [
              _c("el-input", {
                staticStyle: { width: "130px" },
                attrs: { placeholder: "请输入产品ID", clearable: "" },
                model: {
                  value: _vm.searchForm.productId,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "productId", $$v)
                  },
                  expression: "searchForm.productId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "date" },
            [
              _c("el-date-picker", {
                staticClass: "date-picker",
                style: { width: "330px" },
                attrs: {
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  clearable: "",
                  "default-time": ["00:00:00", "23:59:59"],
                },
                on: {
                  blur: function ($event) {
                    _vm.isRestart = true
                  },
                },
                model: {
                  value: _vm.dateValue,
                  callback: function ($$v) {
                    _vm.dateValue = $$v
                  },
                  expression: "dateValue",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { type: "primary", size: "14" },
              on: {
                click: function ($event) {
                  return _vm.queryList("search")
                },
              },
            },
            [_vm._v("查询")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", { staticClass: "num-title" }, [
            _vm._v(
              "总数量：" +
                _vm._s(_vm.totalAmount) +
                "，已使用：" +
                _vm._s(_vm.usageAmount)
            ),
          ]),
          _c(
            "el-button",
            {
              staticClass: "button-container",
              attrs: { type: "primary", size: "14" },
              on: { click: _vm.handleAddOrder },
            },
            [_vm._v("新增订单")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            size: "medium",
            "header-cell-style": { background: "#F5F6F7" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "订单号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.orderNo || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "产品ID" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.productId || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "产品信息" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.productName) +
                        "(" +
                        _vm._s(scope.row.productId || "-") +
                        ")\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "订单说明" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.orderDescription || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.createTime || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "三元组数量", width: "140px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.totalAmount || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "已使用数量", width: "140px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.usageAmount || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "120px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.jumpDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "operate",
                          disabled: scope.row.usageAmount !== "0",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 20, 50],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增订单",
            visible: _vm.dialogVisible,
            width: "596px",
            "before-close": _vm.handleClose,
            "custom-class": "white-list-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.addFormData,
                rules: _vm.rules,
                width: "596px",
                "label-width": "95px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "订单号", prop: "orderNo" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _c("span", [_vm._v("订单号")]),
                          _vm._v(" \n          "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  '订单号不能包括下列字符（\\/:*?"<>|空格）',
                                placement: "top",
                              },
                            },
                            [_c("i", { staticClass: "iconfont icon-wenhao" })]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入订单号",
                      maxlength: "250",
                      clearable: "",
                    },
                    model: {
                      value: _vm.addFormData.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFormData, "orderNo", $$v)
                      },
                      expression: "addFormData.orderNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "产品PID", prop: "productId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入产品PID", clearable: "" },
                    model: {
                      value: _vm.addFormData.productId,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFormData, "productId", $$v)
                      },
                      expression: "addFormData.productId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单说明", prop: "orderDescription" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入订单说明，最多100个字符",
                      type: "textarea",
                      maxlength: "100",
                      "show-word-limit": "",
                      rows: 6,
                      clearable: "",
                    },
                    model: {
                      value: _vm.addFormData.orderDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFormData, "orderDescription", $$v)
                      },
                      expression: "addFormData.orderDescription",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "14" }, on: { click: _vm.handleClose } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "14" },
                  on: { click: _vm.onsubmit },
                },
                [_vm._v("确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }